import * as React from "react";
import { useState } from "react";
import { Spin, Icon } from "antd";
import "./Statements.less";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { PapiClientProps, withPapi } from "../Api/PapiHoc";
import { StatementPeriod, Statement } from "swan-public-api-client";
import { StatementsList } from "./StatementsList";
import { StatementsSearchForm, SearchParameters } from "./StatementsSearchForm";

interface Props extends WrappedComponentProps, PapiClientProps {
  tradingAccountKey: string;
}

function StatementsCmp(props: Props) {
  const [from, setFrom] = useState(undefined as Date | undefined);
  const [to, setTo] = useState(undefined as Date | undefined);
  const [period, setPeriod] = useState(undefined as StatementPeriod | undefined);
  const [hasSearched, setHasSearched] = useState(false);
  const [searching, setSearching] = useState(false);
  const [statements, setStatements] = useState([] as Statement[]);

  const onSearch = async (searchParameters: SearchParameters) => {
    try {
      setSearching(true);
      setHasSearched(true);

      const fetchedStatements = await props.papiClient.getStatements(
        props.tradingAccountKey,
        searchParameters.from,
        searchParameters.to,
        searchParameters.period
      );
      setStatements(fetchedStatements.map(x => x.Content));
    } finally {
      setSearching(false);
    }
  };

  const formAndList = (
    <>
      <StatementsSearchForm
        onSearch={onSearch}
        from={from}
        onFromChange={setFrom}
        to={to}
        onToChange={setTo}
        period={period}
        onPeriodChange={setPeriod}
      />
      <StatementsList
        statements={statements}
        tradingAccountKey={props.tradingAccountKey}
        bordered={false}
        locale={{ emptyText: props.intl.formatMessage({ id: hasSearched ? "statements.emptySearchResultsEmptyText" : "statements.notYetSearchedEmptyText" })}}
      />
    </>
  );

  return (
    <div className="statements">
      {searching
        ? (
          <Spin
            indicator={(<Icon type="loading"/>)}
            tip={props.intl.formatMessage({ id: "statements.searching" })}
            delay={100}
          >
            {formAndList}
          </Spin>
        )
        : formAndList
      }
    </div>
  );
}

const StatementsWithIntl = injectIntl(StatementsCmp);

export const Statements = withPapi(StatementsWithIntl);
